import { render, staticRenderFns } from "./SeeAllConsiderations.vue?vue&type=template&id=38508220&scoped=true"
import script from "./SeeAllConsiderations.vue?vue&type=script&lang=js"
export * from "./SeeAllConsiderations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38508220",
  null
  
)

export default component.exports